module.exports = __webpack_public_path__ + "media/npc_dota_hero_terrorblade.d96e6c2a.webm";